import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { AccountFormTemplate } from '@/components/auth/AccountFormTemplate';
import Modal from '@/components/switchback/Modal';
import { ModalSize } from '@/components/switchback/Modal/Modal';

import ForgotPasswordForm, { ForgotPasswordFormProps } from './ForgotPasswordForm/component';
import { IProps as ILoginFormProps, LoginForm } from './LoginForm';

interface IProps {
  isAuthenticated: boolean;
  isOpen: boolean;
  isClosable: boolean;
  isResettingPassword: boolean;
  onSignup: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  onForgotPassword: () => void;
  onClose: () => void;
  loginFormProps: Omit<ILoginFormProps, 'onForgotPassword' | 'isModal'>;
  resetPasswordFormProps: Omit<ForgotPasswordFormProps, 'onLogin' | 'loginRedirect' | 'hideHeader'>;
}

const LoginModal: React.FC<IProps> = ({
  isAuthenticated,
  isOpen,
  isClosable,
  isResettingPassword,
  onSignup,
  onClose,
  onForgotPassword,
  loginFormProps,
  resetPasswordFormProps,
}) => {
  const intl = useIntl();

  let modalTitle = null;
  let contentComponent = null;

  if (isResettingPassword) {
    modalTitle = intl.formatMessage({
      defaultMessage: 'Reset your password',
      id: 'SU8jJ3',
      description: 'Login Modal Title',
    });

    contentComponent = (
      <ForgotPasswordForm
        {...resetPasswordFormProps}
        onLogin={onForgotPassword}
        hideHeader
        className="pt-3"
      />
    );
  } else {
    modalTitle = intl.formatMessage({
      defaultMessage: 'Log in with your email',
      id: 's/9dk9',
      description: 'Login Modal Title',
    });

    contentComponent = (
      <AccountFormTemplate onSignup={onSignup} className="pt-3">
        <LoginForm {...loginFormProps} onForgotPassword={onForgotPassword} isModal />
      </AccountFormTemplate>
    );
  }

  useEffect(() => {
    if (isAuthenticated && isOpen) {
      onClose();
    }
  }, [isAuthenticated, isOpen, onClose]);

  return (
    <Modal
      size={ModalSize.medium}
      open={isOpen}
      onClose={isClosable ? onClose : undefined}
      data-testid="login-modal"
      title={modalTitle}
      titleClass="font-medium"
      className="!z-[1401]">
      {contentComponent}
    </Modal>
  );
};

export default LoginModal;
